import React, { useState } from 'react'
import { navigate } from 'gatsby'
import loadable from '@loadable/component'
import ModalBox from '../../molecules/ModalBox'
import { Wrapper, ModalWrapper } from './styled'
import { getStoredMarket } from '../../../utils/store'
import { Props } from './libs'
import { AuthFormType } from '../../../types'

const FormGuest = loadable(() => import('../FormGuest'))
const FormSignUp = loadable(() => import('../FormSignUp'))
const FormSignIn = loadable(() => import('../FormSignIn'))

const AuthWidget = (widgetProps: Props) => {
  const { title, onClose, noClose, showWidget, closeWidget, useModal = true, setIsLoadingUserData } = widgetProps

  const [isLoading, setIsLoading] = useState(false)
  const [boxTitle, setBoxTitle] = useState<string>()

  const modalBoxProps = { onClose, title: boxTitle || title }

  const mergeProps = <T extends Record<string, unknown>>(currentProps: T) => ({
    ...currentProps,
    onClickSignUp: () => showWidget(AuthFormType.SIGNUP),
    onClickSignIn: () => showWidget(AuthFormType.SIGNIN),
    onCloseModal: () => closeWidget(),
    useModal: useModal ?? false,
    onSend: () => {
      if (widgetProps.formSettings.props?.onSend) widgetProps.formSettings.props.onSend()

      setIsLoading(true)
    },
    onError: () => {
      if (widgetProps.formSettings.props?.onError) widgetProps.formSettings.props.onError()

      setIsLoading(false)
    },
    onClickSignUpConfirm: () => {
      setBoxTitle('Confirma tu cuenta')
      setIsLoading(false)
    },
    onClickResetPassword: async (e: React.MouseEvent) => {
      e.preventDefault()
      e.stopPropagation()

      const currentCity = getStoredMarket()
      await navigate(currentCity && currentCity?.slug ? `/reset-password` : '/')
    },
    setLoading: (loading: boolean) => setIsLoading(loading),
    loading: isLoading,
    setIsLoadingUserData: (isLoadingUserData: boolean) =>
      setIsLoadingUserData && setIsLoadingUserData(isLoadingUserData),
  })

  const renderForm = () => {
    switch (widgetProps.formSettings.type) {
      case AuthFormType.GUEST: {
        return <FormGuest {...mergeProps(widgetProps.formSettings.props)} />
      }

      case AuthFormType.SIGNUP: {
        return <FormSignUp {...mergeProps(widgetProps.formSettings.props)} />
      }

      case AuthFormType.SIGNIN: {
        return <FormSignIn {...mergeProps(widgetProps.formSettings.props)} />
      }

      default:
        return null
    }
  }

  if (!useModal) return <Wrapper>{renderForm()}</Wrapper>

  return (
    <ModalBox noClose={noClose || isLoading} {...modalBoxProps} showContentTitle>
      <ModalWrapper>{renderForm()}</ModalWrapper>
    </ModalBox>
  )
}

export default AuthWidget
